// framework/client/components/ChartWidget.js
import { WidgetBase } from "../core/WidgetBase.js";

export class ChartWidget extends WidgetBase {
    constructor(config) {
        super(config);
        this.chart = null;
        this.canvas = null;
    }

    async initialize() {
        this.canvas = document.createElement('canvas');
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        await super.initialize();
    }

    // --- NEW HELPER METHOD ---
    _resolveThemeColors(configObject) {
        if (!configObject) return configObject;

        // Create a deep copy to avoid modifying the original config object
        const resolvedObject = JSON.parse(JSON.stringify(configObject));

        const resolve = (obj) => {
            for (const key in obj) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    resolve(obj[key]); // Recurse into nested objects/arrays
                } else if (typeof obj[key] === 'string' && obj[key].startsWith('var(--')) {
                    // It's a CSS variable string, resolve it
                    const varName = obj[key].match(/--[\w-]+/)[0];
                    if (varName) {
                        obj[key] = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
                    }
                }
            }
        };

        resolve(resolvedObject);
        return resolvedObject;
    }
    // --- END NEW HELPER METHOD ---

    async renderContent() {
        if (this.error) {
            this.contentContainer.innerHTML = `<div class="widget-error">Error: ${this.error.message}</div>`;
            return;
        }

        if (this.isLoading) { return; }

        const mainData = this.data?.main;

        if (!mainData || !Array.isArray(mainData) || mainData.length === 0) {
            this.contentContainer.innerHTML = `<div class="data-widget-no-data">${this.t(this.config.widget.noDataMessage || 'No data to display.')}</div>`;
            this.appClient.tx.applyTranslations(this.contentContainer);
            return;
        }

        if (this.chart) this.chart.destroy();

        this.contentContainer.innerHTML = '';
        this.contentContainer.appendChild(this.canvas);

        // --- MODIFIED SECTION ---
        // Resolve theme colors before creating the chart
        const resolvedDatasetOptions = this._resolveThemeColors(this.config.widget.datasetOptions);
        const resolvedOptions = this._resolveThemeColors(this.config.widget.options);
        // --- END MODIFICATION ---

        this.chart = new Chart(this.canvas, {
            type: this.config.widget.chartType,
            data: {
                labels: mainData.map(item => item[this.config.widget.labelsField]),
                datasets: [{
                    label: this.config.widget.datasetOptions?.label || '',
                    data: mainData.map(item => item[this.config.widget.dataField]),
                    ...resolvedDatasetOptions // Use the resolved options
                }]
            },
            options: resolvedOptions || {} // Use the resolved options
        });
    }

    resize() {
        if (this.chart) {
            this.chart.resize();
        }
    }

    destroy() {
        if (this.chart) this.chart.destroy();
        super.destroy();
    }
}